import React, { useState, useRef } from 'react';
import { motion, AnimatePresence, useInView } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
interface Bonus {
  id: string;
  title: string;
  image: string;
  shortDesc: string;
  details: string;
}
const BONUSES: Bonus[] = [{
  id: 'bono-1',
  title: 'Menús Express Menopausia 7 Días',
  image: 'https://cdn.magicpatterns.com/uploads/7QkdmuuuSeWQkHq31g1xKx/Bono_1_portada.png',
  shortDesc: '7 días de menús antiinflamatorios diseñados para el metabolismo femenino después de los 50. Sencillos, rápidos y deliciosos.',
  details: 'Incluye desayunos, comidas y cenas organizadas por día. Cada menú fue seleccionado para reducir la inflamación, equilibrar el cortisol y darte energía estable a lo largo del día. Sin contar calorías, sin ingredientes raros, sin complicaciones.'
}, {
  id: 'bono-2',
  title: 'Checklist Nocturna Anti-Despertares',
  image: 'https://cdn.magicpatterns.com/uploads/bPc73xN9fr8F8R5PPeeN8H/Bono_2_portada.png',
  shortDesc: 'Una rutina de 10 minutos antes de dormir para reducir los despertares nocturnos y lograr un sueño más profundo y reparador.',
  details: 'Incluye una secuencia de pasos simples que preparan tu sistema nervioso para el descanso. Diseñada específicamente para mujeres que se despiertan entre las 2 y las 4 AM por razones hormonales y metabólicas. Lista para usar desde la primera noche.'
}, {
  id: 'bono-3',
  title: 'Guía Rápida de Desayunos que Dan Energía',
  image: 'https://cdn.magicpatterns.com/uploads/3sD2gZT3eS4PmHvjkQBpBy/Bono_3_portada.png',
  shortDesc: 'Los desayunos exactos que activan tu metabolismo desde la primera hora del día y evitan las caídas de energía a media mañana.',
  details: 'Incluye recetas rápidas de menos de 15 minutos, con ingredientes accesibles en cualquier supermercado mexicano. Cada desayuno fue diseñado para estabilizar el cortisol matutino, activar el metabolismo y mantenerte con energía y claridad mental hasta la tarde. Sin azúcar, sin harinas, sin hambre a las 10 AM.'
}];
export function BonusSection() {
  return <section className="py-12 md:py-16 bg-[#faf6ee]" data-id="element-10">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-11">
        <div className="text-center mb-12" data-id="element-12">
          <div className="inline-block bg-[#c9a961]/20 text-[#b8954d] px-4 py-1.5 rounded-full text-xs font-bold tracking-widest uppercase mb-4 border border-[#c9a961]/30" data-id="element-13">
            🎁 INCLUYE 3 BONOS GRATIS
          </div>
          <p className="text-lg md:text-xl text-[#b8954d] font-medium" data-id="element-14">
            Valorados en $81 USD — Hoy son tuyos sin costo adicional
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-15">
          {BONUSES.map((bonus, idx) => <BonusCard key={bonus.id} bonus={bonus} index={idx} data-id="element-16" />)}
        </div>
      </div>
    </section>;
}
function BonusCard({
  bonus,
  index
}: {
  bonus: Bonus;
  index: number;
}) {
  const [isOpen, setIsOpen] = useState(false);
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-50px'
  });
  return <motion.div ref={ref} initial={{
    opacity: 0,
    y: 30
  }} animate={isInView ? {
    opacity: 1,
    y: 0
  } : {}} transition={{
    duration: 0.6,
    delay: index * 0.1
  }} className="bg-white rounded-2xl shadow-md overflow-hidden flex flex-col" data-id="element-17">
      <div className="relative bg-[#faf6ee] aspect-[16/10] overflow-hidden" data-id="element-18">
        <img src={bonus.image} alt={bonus.title} className="w-full h-full object-contain" data-id="element-19" />
        <div className="absolute top-4 right-4 bg-[#5d6e4f] text-white px-3 py-1 rounded-full text-xs font-bold tracking-wide shadow-md" data-id="element-20">
          GRATIS
        </div>
      </div>

      <div className="p-6 flex flex-col flex-grow" data-id="element-21">
        <h3 className="font-serif text-xl text-[#2d2d2d] mb-3 leading-snug" data-id="element-22">
          {bonus.title}
        </h3>

        <div className="flex items-center gap-2 mb-4" data-id="element-23">
          <span className="text-sm text-[#a8a8a8] line-through" data-id="element-24">
            Valor: $27 USD
          </span>
          <span className="text-sm font-bold text-[#5d6e4f]" data-id="element-25">GRATIS</span>
        </div>

        <p className="text-sm text-[#2d2d2d] leading-relaxed mb-6 flex-grow" data-id="element-26">
          {bonus.shortDesc}
        </p>

        <div className="border-t border-gray-100 pt-4 mt-auto" data-id="element-27">
          <button onClick={() => setIsOpen(!isOpen)} className="w-full flex items-center justify-between text-sm font-medium text-[#7a8a6b] hover:text-[#5d6e4f] transition-colors" data-id="element-28">
            <span data-id="element-29">Más información</span>
            <motion.div animate={{
            rotate: isOpen ? 180 : 0
          }} data-id="element-30">
              <ChevronDownIcon className="w-4 h-4" data-id="element-31" />
            </motion.div>
          </button>

          <AnimatePresence data-id="element-32">
            {isOpen && <motion.div initial={{
            height: 0,
            opacity: 0
          }} animate={{
            height: 'auto',
            opacity: 1
          }} exit={{
            height: 0,
            opacity: 0
          }} className="overflow-hidden" data-id="element-33">
                <p className="pt-4 text-sm text-[#2d2d2d] leading-relaxed" data-id="element-34">
                  {bonus.details}
                </p>
              </motion.div>}
          </AnimatePresence>
        </div>
      </div>
    </motion.div>;
}